import { WashDto, WashReferenceDto } from "@/core/api/generated/v1";

/** Any entity DTO type according to @type EntityFormType */
export type WashDtoAny = WashDto | WashReferenceDto;

/** All entity DTO types according to @type EntityFormType */
export type WashDtoAll = WashDto & WashReferenceDto;

export class WashMapper {}
